import Vue from 'vue';
import VueI18n from 'vue-i18n';
import en from './assets/locales/en.json';
import es from './assets/locales/es.json';

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: 'en',
  fallbackLocale: false,
  messages: { en, es },

  silentFallbackWarn: true,
  returnNull: false,
  returnEmptyString: false,

  missing(locale, key) {
    console.warn(`[i18n] Missing ${locale}: ${key}`)
    return key
  }
});

export default i18n;



// WEBPACK FOOTER //
// ./src/i18n.js